import React from 'react';
import PropTypes from 'prop-types';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import {useDispatch} from 'react-redux';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import PipettingItemReuseTip from 'contents/ProtocolEditor/TaskList/PipettingProfile/PipettingProfileItem/PipettingItemReuseTip';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import {ExecutionStatus} from 'constants/dataEnum';
import {parseMessage} from 'lib/stringHelper';

import '../../Task.scss';
import {generateDilutionTransferTasksSummary as generateDilutionTransferDescriptionSummary} from 'stores/business/taskListSerialDilutionBusiness';
import SerialDilutionTransferPipettingProfile from './SerialDilutionTransferPipettingProfile';

function TaskDescriptionDilutionTransfer({wellGroup}) {
  return (
    <>
      &nbsp;
      <span>
        in
        {wellGroup}
      </span>
    </>
  );
}

TaskDescriptionDilutionTransfer.propTypes = {
  wellGroup: PropTypes.any.isRequired,
};

function TaskDilutionTransfer({
  tasks,
  number,
  processedTasks,
  isSelected,
  sdProperty,
  runtimeMode,
  readOnly,
  executionStatus,
  onEdit,
  onSelectTask,
  onReuseTipsChange,
  showPipettingParameter,
}) {
  const dispatch = useDispatch();

  const taskTitle = 'Dilution Transfer';
  const wellGroupName = dispatch(generateDilutionTransferDescriptionSummary(tasks, sdProperty));

  const {reuseTips} = sdProperty || {};

  const tooltipLabel = parseMessage('protocolEditor.serialDilution.reuseTip.info');

  return (
    <TaskWrapper isSelected={isSelected} onClick={onSelectTask}>
      <TaskNumber number={number} isHighlighted={isSelected} />
      <TaskTitle title={taskTitle} description={<TaskDescriptionDilutionTransfer wellGroup={wellGroupName} />} />
      {!runtimeMode && !readOnly && <TaskAction onEdit={onEdit} />}
      {showPipettingParameter && (
        <TaskPipettingProfileWrapper>
          <PipettingItemReuseTip
            toolTipTitle={tooltipLabel}
            reuseTips={reuseTips}
            onReuseTipsChange={onReuseTipsChange}
          />
          <SerialDilutionTransferPipettingProfile runtimeMode={runtimeMode} tasks={processedTasks} />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

TaskDilutionTransfer.propTypes = {
  runtimeMode: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onReuseTipsChange: PropTypes.func.isRequired,
  tasks: PropTypes.object.isRequired,
  processedTasks: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  sdProperty: PropTypes.object.isRequired,
  showPipettingParameter: PropTypes.bool.isRequired,
  number: PropTypes.any.isRequired,
};

export default TaskDilutionTransfer;
